import React from 'react';
import { Bot, Info } from 'lucide-react';
import { fmtInt, fmtTokens } from './format';

const List = ({ title, rows, nameOf, testid }) => (
  <div data-testid={testid}>
    <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1.5">{title}</p>
    {rows.length === 0 ? <p className="text-xs text-muted-foreground">Noch keine Anfragen.</p> : rows.map((r, i) => (
      <div key={i} className="flex items-center justify-between text-xs border-b border-border/50 py-1.5" data-testid={`${testid}-row-${i}`}>
        <span className="text-foreground font-mono truncate">{nameOf(r)}</span>
        <span className="font-mono text-muted-foreground shrink-0">{fmtInt(r.calls)} Anfrage{r.calls !== 1 ? 'n' : ''}
          <span className="text-orange-300 ml-3">≈ {fmtTokens(r.approx_tokens)} Tok.</span>
        </span>
      </div>
    ))}
  </div>
);

export const ClaudeConnectUsageCard = ({ cc }) => (
  <div className="bg-card border border-orange-500/30 rounded-sm p-4 space-y-4" data-testid="ai-costs-claude-connect-card">
    <div>
      <div className="flex items-center gap-2">
        <Bot className="w-4 h-4 text-orange-300" />
        <p className="font-heading text-base text-foreground">Claude Connect</p>
      </div>
      <p className="text-[11px] text-muted-foreground mt-1 flex items-start gap-1.5">
        <Info className="w-3.5 h-3.5 shrink-0 mt-0.5 text-orange-300" />
        <span>Verbraucht <strong className="text-foreground">keine OLTA-KI-Credits</strong> — Claude liest nur Daten aus OLTA; die Claude-Nutzung läuft über euer Claude-Abo.
          Gezählt werden Anfragen und das übertragene Datenvolumen (≈ Tokens, die Claude als Kontext erhält).</span>
      </p>
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div className="border border-border rounded-sm bg-secondary/30 p-3">
        <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Anfragen</p>
        <p className="font-mono text-lg font-bold text-orange-300 mt-0.5" data-testid="ai-costs-claude-calls">{fmtInt(cc.calls)}</p>
        {cc.errors > 0 && <p className="text-[10px] text-red-400 font-mono">{cc.errors} fehlgeschlagen</p>}
      </div>
      <div className="border border-border rounded-sm bg-secondary/30 p-3">
        <p className="text-[10px] text-muted-foreground uppercase tracking-wider">Datenvolumen</p>
        <p className="font-mono text-lg font-bold text-foreground mt-0.5" data-testid="ai-costs-claude-tokens">≈ {fmtTokens(cc.approx_tokens)} Tokens</p>
      </div>
    </div>
    <List title="Nach Person" rows={cc.by_user} nameOf={r => r.user_name} testid="ai-costs-claude-by-user" />
    <List title="Nach Werkzeug" rows={cc.by_tool} nameOf={r => r.tool} testid="ai-costs-claude-by-tool" />
  </div>
);
